'use client';

import { useState } from 'react';

import styles from 'molecules/Form/radiogroup/radio.module.scss';

import type { FC } from 'react';

type FormStateProps = {
  checked?: boolean;
  multiple?: boolean;
  name?: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
};

type RadioProps = {
  formStateProps?: FormStateProps;
  disabled?: boolean;
  id: string;
  label: string;
  required: boolean;
  validate?: (fieldName: string, value: string, required: boolean) => void;
  validateOnBlur?: (fieldName: string, value: string, required: boolean) => void;
  validateOnChange?: (fieldName: string, value: string, required: boolean) => void;
};

const Radio: FC<RadioProps> = ({
  formStateProps = {},
  label,
  id,
  disabled,
  validate,
  required = false,
  validateOnBlur,
  validateOnChange,
}) => {
  const [value, setValue] = useState<string>(formStateProps.value || '');
  const { onChange: outerOnChange, ...passFormStateProps } = formStateProps;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    validateOnChange?.(id, e.target.value, required);
    if (outerOnChange) {
      outerOnChange(e);
    }
  };

  const handleBlur = () => {
    validateOnBlur?.(id, value, required);
    {
      validate && validate(id, value, required);
    }
  };

  return (
    <div className={styles.wrapper}>
      <input
        {...passFormStateProps}
        className={styles.radio}
        type="radio"
        id={id}
        checked={formStateProps.checked || false}
        disabled={disabled || false}
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default Radio;
